import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { BaseComponent } from '../base/base.component';

@Component({
  selector: 'app-sejam',
  templateUrl: './sejam.component.html',
  styleUrls: ['./sejam.component.scss']
})
export class SejamComponent extends BaseComponent implements OnInit {

  constructor(private title: Title) {

    super();
    this.title.setTitle('کارگزاری آبان |  ثبت نام در سامانه سجام و دریافت کد بورسی')
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

}
